<script setup>
import { defineEmits, defineProps, ref } from 'vue'
import { useRouter } from 'vue-router'
// const props = defineProps('jump')
const emit = defineEmits(['jump'])
const router = useRouter()
const textData = [
  {
    id: '产品方案',
    title: '产品方案',
    children: [
      {
        router: '/product/goldenBrain',
        name: '产业金脑',
      },
      {
        router: '/product/industryResearch',
        name: '数字产研',
      },
      {
        router: '/product/attractInvestment',
        name: '数智招商',
      },
    ],
    // select: ['产业金脑', '数字产研', '数智招商']
  },
  {
    id: '数据报告',
    title: '数据报告',
    children: [
      {
        router: '/report/1',
        name: '产业洞察',
      },
      {
        router: '/report/2',
        name: '专题报告',
      },
      {
        router: '/report/3',
        name: '智能研报',
      },
    ],
    // select: ['产业洞察', '专题报告', '智能研报']
  },
  {
    id: '关于我们',
    title: '关于我们',
    children: [
      {
        router: '/aboutUs/01',
        name: '公司简介',
      },
      {
        router: '/aboutUs/02',
        name: '联系我们',
      },
    ],
    // select: ['公司简介', '联系我们']
  },
]
const show = ref(false)
const changeRoute = (child) => {
  emit('jump', child.router)
}
const showDialog = () => {
  router.replace({
    path: '/consultUsForm/consult',
  })
}
</script>

<template>
  <div class="footer w-full relative">
    <!-- 上 -->
    <div
      class="py-[64px] w-full text-center text-white"
    >
      <div class="w-full text-[28px] font-bold leading-[40px] mb-4">
        携手共创产业未来
      </div>
      <div class="text-[24px] mb-[6px]">
        让我们用专业的服务和先进的技术
      </div>
      <div class="text-[24px]">
        助力您的产业发展和区域经济增长
      </div>
    </div>
    <div class="flex justify-center items-center gap-8">
      <div>
        <div
          class="chatImg w-[200px] h-[200px]"
        />
        <div
          class="text-center text-[24px] text-white mt-4"
        >
          客服二维码
        </div>
      </div>
      <div>
        <div
          class="chatImg2 w-[200px] h-[200px] "
        />
        <div
          class="text-center text-[24px] text-white mt-4"
        >
          公众号二维码
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-y-[24px] items-center justify-center mt-10">
      <div
        class="logo w-[246px] h-[40px]"
      />
      <div class="text-white text-[24px] text-center flex items-center">
        <!-- 图标 -->
        <img class="w-[24px] h-[24px] mr-1" src="https://static.idicc.cn/cdn/official/H5/home_tel.png" alt="">
        电话：13396811959
      </div>
      <div class="text-white text-[24px] text-center flex items-center">
        <!-- 图标 -->
        <img class="w-[24px] h-[24px] mr-1" src="https://static.idicc.cn/cdn/official/H5/home_email.png" alt="">
        邮箱：admin@idicc.cn
      </div>
      <div class="text-white text-[24px] text-center flex items-center">
        <!-- 图标 -->
        <img class="w-[24px] h-[24px] mr-1" src="https://static.idicc.cn/cdn/official/H5/home_adress.png" alt="">
        地址：杭州余杭区浙江大学校友企业总部经济园11幢13F
      </div>
    </div>

    <div
      class="w-full flex justify-center items-center pt-6 pb-3 text-[20px] text-white flex-wrap"
    >
      <img class="h-[20px] px-1" src="@/assets/imgs/gongshang.png">
      <img
        class="h-[20px]"
        src="https://gw.alicdn.com/tfs/TB1jwakrbH1gK0jSZFwXXc7aXXa-20-20.png"
      >
      <a
        class="px-2"
        target="_blank"
        href="https://beian.miit.gov.cn/#/Integrated/index"
      >浙ICP备2023019449号</a>
      <span>艾瑞数云科技(杭州)有限公司</span>
    </div>
  </div>
</template>

<style lang="less">
 .footer {
    width: 100%;
    height: 100%;
    background: center / contain no-repeat
      url("https://static.idicc.cn/cdn/official/H5/home_bottom_bg.png");
    background-size: 100% 100%;
  }
.footerChat {
  background: center / contain no-repeat url("@/assets/imgs/homes/chat_bg.png");
}

.chatImg {
  flex-flow: column-reverse;
  background: center / contain no-repeat
     url("https://static.idicc.cn/cdn/official/H5/serviceCode.png");
  background-size: 100% 100%;
}
.chatImg2 {
  flex-flow: column-reverse;
  background: center / contain no-repeat
     url("https://static.idicc.cn/cdn/official/H5/weChatCode.png");
  background-size: 100% 100%;
}

.logo {
  background: center / contain no-repeat
     url("https://static.idicc.cn/cdn/official/H5/logo2.png");
  background-size: 100% 100%;
}
.flex-between {
  justify-content: space-around;
}
</style>
